const buildCustomListProductListInput = items =>
  (items || []).map(item => ({
    id: item.productId,
    category: item.categorySlug || '',
    selectedOptions: (item.selectedOptions || []).map(option => ({
      optionId: option.optionId ?? null,
      optionType: option.optionType || '',
      optionValue: option.optionValue || '',
      optionValueId: option.optionValueId ?? null,
      optionValueSku: option.optionValueSku || '',
    })),
  }));

export default buildCustomListProductListInput;
